package co.uk.sacursoftware.ssinventory.data.remote

object DatabaseConfig {
    var variant: String = "bradford"
}

expect fun getDatabaseVariant(): String
